/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ComponentIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "component", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M12.5 4L21 12.5L12.5 21L4 12.5L12.5 4Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M8.5 8.5L16.5 16.5M16.5 8.5L8.5 16.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ComponentIcon);
export default ForwardRef;
//# sourceMappingURL=componentIcon.js.map